import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MethodSettlementService {

  constructor(private http: HttpClient) { }

  // Get settlement array - action_id=33349
  getSettlementArray(baseUrl: string, params: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=33349`;
    
    let mergedParams = _.merge({}, filterParams, params);
    mergedParams = _.merge({}, globalService?.globalParams || {}, mergedParams);
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        formData.set(key, mergedParams[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Save settlement array
  saveSettlementArray(baseUrl: string, returnObj: any, settlementArray: any[], globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveMethodOfSettlement`;
    
    let params = _.merge({}, filterParams, returnObj);
    params.is_issue_key_enabled = 'N';
    params.scenarioCode = 'RAF';
    
    if (!params.scenario) {
      params.scenario = '1';
    }
    
    const jsonObj = JSON.stringify(settlementArray);
    params = _.merge({}, globalService?.globalParams || {}, params);
    params.jsonObj = jsonObj;
    params.username = globalService?.userSettingsData?.user?.first_name + ' ' + globalService?.userSettingsData?.user?.last_name;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Delete settlement - action_id=38
  deleteSettlement(baseUrl: string, rowData: any, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    let params: any = {
      action_id: 38,
      leid: rowData.LEID,
      division: rowData.Division
    };
    
    params = _.merge({}, globalService?.globalParams || {}, filterParams, params);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Validate BUC/ADN - action_id=33350
  validateBucAdn(baseUrl: string, bucCode: string, adnCode: string, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_id=33350`;
    
    let params: any = {
      buc_code: bucCode,
      adn_code: adnCode,
      is_issue_key_enabled: 'N',
      scenarioCode: 'RAF'
    };
    
    params = _.merge({}, filterParams, params);
    params = _.merge({}, globalService?.globalParams || {}, params);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Get company codes - action_id=37
  getCompanyCodes(baseUrl: string, searchString: string, globalService: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    const params: any = {
      action_id: 37,
      search_string: searchString
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Get banker array - action_id=33347
  getBankerArray(baseUrl: string, leid: string, division: string, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=33347`;
    
    let params: any = {
      leid: leid,
      division: division
    };
    
    params = _.merge({}, filterParams, params);
    params = _.merge({}, globalService?.globalParams || {}, params);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }

  // Set banker - action_id=33348
  setBanker(baseUrl: string, leid: string, division: string, globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_id=33348`;
    
    let params: any = {
      leid: leid,
      division: division,
      is_issue_key_enabled: 'N',
      scenarioCode: 'RAF'
    };
    
    params = _.merge({}, filterParams, params);
    params = _.merge({}, globalService?.globalParams || {}, params);
    
    if (!params.scenario) {
      params.scenario = '1';
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData.toString(), httpOptions);
  }
}
